<template>
  <div class="product-breadcrumbs">
    <div class="product-breadcrumbs__categories-wrap">
      <div v-if="props.typeHandle && getTranslatedTypeName(props.typeHandle)">
        <div
          class="product-breadcrumbs__product-type handle text-small3 is-medium-bold"
        >
          <NuxtLink
            class="default-hover text-small3 is-medium-bold"
            :to="
              localePath({
                name: getTypeRoute(props.typeHandle),
              })
            "
          >
            <span>{{ getTranslatedTypeName(props.typeHandle) }}</span>
          </NuxtLink>
        </div>
      </div>
      <div
        class="product-breadcrumbs__list"
        v-if="props.categories && props.categories.length"
      >
        <div
          v-for="(category, index) in props.categories"
          :key="index"
          class="text-small3 is-medium-bold"
        >
          <div class="product-breadcrumbs__category">
            <NuxtLink
              class="default-hover text-small3 is-medium-bold"
              :to="
                localePath({
                  name:
                    props.typeHandle === 'vino' ? 'vino-slug' : 'birra-slug',
                  params: {
                    slug: category.slug,
                  },
                })
              "
            >
              <span>{{ category.title }}</span>
            </NuxtLink>
          </div>
        </div>
      </div>
      <div
        class="product-breadcrumbs__list"
        v-if="props.subcategories && props.subcategories.length"
      >
        <div
          v-for="(item, index) in props.subcategories"
          :key="index"
          class="product-breadcrumbs__subcategory text-small3 is-medium-bold"
        >
          <NuxtLink
            class="default-hover text-small3 is-medium-bold"
            :to="
              localePath({
                name: typeHandle === 'vino' ? 'vino-slug-sottocategoria' : '',
                params: {
                  slug: item.categorySlug,
                  sottocategoria: item.slug,
                },
              })
            "
          >
            <span v-html="item.title" />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  categories: Array,
  subcategories: Array,
  typeHandle: String,
})

const { t } = useI18n()

const typeRoutes = {
  vino: 'vino',
  birra: 'birra',
  prodottoPanificati: 'panificati',
  prodottoAgricoltura: 'agricoltura',
  prodottoNutraceutica: 'nutraceutica',
}

const getTypeRoute = (typeHandle) => typeRoutes[typeHandle] || ''

const typeTranslations = {
  vino: 'product.vino',
  birra: 'product.birra',
  prodottoPanificati: 'product.panificati',
  prodottoAgricoltura: 'product.agricoltura',
  prodottoNutraceutica: 'product.nutraceutica',
}

const getTranslatedTypeName = (typeHandle) => {
  if (typeTranslations[typeHandle]) {
    return t(typeTranslations[typeHandle])
  }
  return ''
}
</script>

<script>
export default {
  name: 'ProductBreadcrumbs',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
